'use client';
import { callAllHandlers } from '@chakra-ui/utils/call-all';
import { useCallback } from 'react';
import { useTabsContext, useTabsDescendantsContext } from './tabs-context.mjs';

function useTabList(props) {
  const { focusedIndex, orientation, direction } = useTabsContext();
  const descendants = useTabsDescendantsContext();
  const onKeyDown = useCallback(
    (event) => {
      const nextTab = () => {
        const next = descendants.nextEnabled(focusedIndex);
        if (next)
          next.node?.focus();
      };
      const prevTab = () => {
        const prev = descendants.prevEnabled(focusedIndex);
        if (prev)
          prev.node?.focus();
      };
      const firstTab = () => {
        const first = descendants.firstEnabled();
        if (first)
          first.node?.focus();
      };
      const lastTab = () => {
        const last = descendants.lastEnabled();
        if (last)
          last.node?.focus();
      };
      const isHorizontal = orientation === "horizontal";
      const isVertical = orientation === "vertical";
      const eventKey = event.key;
      const ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
      const ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
      const keyMap = {
        [ArrowStart]: () => isHorizontal && prevTab(),
        [ArrowEnd]: () => isHorizontal && nextTab(),
        ArrowDown: () => isVertical && nextTab(),
        ArrowUp: () => isVertical && prevTab(),
        Home: firstTab,
        End: lastTab
      };
      const action = keyMap[eventKey];
      if (action) {
        event.preventDefault();
        action(event);
      }
    },
    [descendants, focusedIndex, orientation, direction]
  );
  return {
    ...props,
    role: "tablist",
    "aria-orientation": orientation,
    onKeyDown: callAllHandlers(props.onKeyDown, onKeyDown)
  };
}

export { useTabList };
